export const FormSamplesDisableFormPageInfo = () => {
  return (
    <>
        All controls support a disabled prop.<br />
        To disable the whole form add the disableForm prop to the Form component like this example does
    </>
  )
}
